import React, { useState } from "react";
import "./Staff.css"; 

const initialStaffList = [
  { id: 1, name: "John Doe", position: "Manager", email: "john@example.com", phone: "123-456-7890", department: "Management" },
  { id: 2, name: "Jane Smith", position: "HR", email: "jane@example.com", phone: "987-654-3210", department: "Human Resources" },
  { id: 3, name: "Alice Johnson", position: "Sale", email: "alice@example.com", phone: "456-789-1230", department: "Sale" },
  { id: 4, name: "Bob Brown", position: "Sale", email: "bob@example.com", phone: "321-654-9870", department: "Sale" },
];

const Staff = () => {
  const [staffList, setStaffList] = useState(initialStaffList);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [newStaff, setNewStaff] = useState({ name: "", position: "", email: "", phone: "", department: "" });
  const [isAdding, setIsAdding] = useState(false);

  const handleAddStaff = () => {
    if (!newStaff.name || !newStaff.position || !newStaff.email) return;
    setStaffList([...staffList, { ...newStaff, id: staffList.length + 1 }]);
    setNewStaff({ name: "", position: "", email: "", phone: "", department: "" });
    setIsAdding(false);
  };

  const handleCancel = () => {
    setNewStaff({ name: "", position: "", email: "", phone: "", department: "" });
    setIsAdding(false);
  };

  return (
    <div className="max-w-4xl mx-1 mt-1 rounded-xl flex overflow-hidden p-[10px]">
      <div style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>スタッフ</h2>
          <button className="mb-2 px-3 py-1 bg-blue-500 text-white hover:bg-blue-600 transition text-sm"
            onClick={() => setIsAdding(!isAdding)}
          >
            {isAdding ? "閉じる" : "新規スタッフ追加"}
          </button>
        </div>

        {isAdding && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="grid grid-cols-2 gap-4">
              <input type="text" placeholder="氏名" className="p-2 border rounded" value={newStaff.name} onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })} />
              <input type="text" placeholder="役職" className="p-2 border rounded" value={newStaff.position} onChange={(e) => setNewStaff({ ...newStaff, position: e.target.value })} />
              <input type="email" placeholder="メール" className="p-2 border rounded" value={newStaff.email} onChange={(e) => setNewStaff({ ...newStaff, email: e.target.value })} />
              <input type="text" placeholder="電話" className="p-2 border rounded" value={newStaff.phone} onChange={(e) => setNewStaff({ ...newStaff, phone: e.target.value })} />
              <input type="text" placeholder="部署" className="p-2 border rounded" value={newStaff.department} onChange={(e) => setNewStaff({ ...newStaff, department: e.target.value })} />
            </div>
            <div className="mt-4 flex justify-between">
              <button className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition" onClick={handleCancel}>
                キャンセル
              </button>
              <button className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition" onClick={handleAddStaff}>
                保存
              </button>
            </div>
          </div>
        </div>
      )}

        <div className="table-container">
          <table className="custom-table compact-table">
            <thead>
                <tr>
                  <th>ID</th>
                  <th>氏名</th>
                  <th>役職</th>
                  <th>メール</th>
                </tr>
            </thead>
            <tbody>
              {staffList.map((staff, index) => (
                <tr key={staff.id} className={index % 2 === 0 ? 'selected' : ''} onClick={() => setSelectedStaff(staff)}>
                  <td>{staff.id}</td>
                  <td>{staff.name}</td>
                  <td>{staff.position}</td>
                  <td>{staff.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {selectedStaff && (
        <div style={{ marginTop: 18 }} className="order-card-infomation-detail">
          <h1>Staff Details</h1>
          <div className="order-edit-form-container" style={{ marginTop: 8 }}>
            <div className="order-info-body">
              <div className="info-field"><label>氏名</label><div>{selectedStaff.name}</div></div>
              <div className="info-field"><label>役職</label><div>{selectedStaff.position}</div></div>
              <div className="info-field"><label>メール</label><div>{selectedStaff.email}</div></div>
              <div className="info-field"><label>電話</label><div>{selectedStaff.phone}</div></div>
              <div className="info-field"><label>部署</label><div>{selectedStaff.department}</div></div>
            </div>
            <div className="order-info-footer">
              <button className="btn btn--secondary" onClick={() => setSelectedStaff(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Staff;


